module.exports = __webpack_public_path__ + "static/media/general-sugery-1@3x.49159d3f.png";